import { ServiceAPI } from "@/api/service";
import websocket from "@/websocket";
import { MasterServiceMutationHandler } from "./mutationHandler";
import type {
  tChangeMasterServicePositionArgs,
  tCreateMasterServiceArgs,
  tMasterService,
  tUpdateMasterServiceArgs,
} from "@/types";

export const MasterServicesService = {
  async createService(data: tCreateMasterServiceArgs) {
    const { data: service } = await ServiceAPI.create(data);
    websocket.execIfNotConnected(() => {
      MasterServiceMutationHandler.serviceCreated({ service });
    });
    return service;
  },
  async updateService(id: string, data: tUpdateMasterServiceArgs) {
    const { data: service } = await ServiceAPI.updateById(id, data);
    websocket.execIfNotConnected(() => {
      MasterServiceMutationHandler.serviceUpdated({ updated_service: service });
    });
    return service;
  },
  async deleteService(service: tMasterService) {
    const id = service._id;
    const { data: removedService } = await ServiceAPI.deleteById(id);
    websocket.execIfNotConnected(() => {
      MasterServiceMutationHandler.serviceRemoved({
        service: removedService,
      });
    });
    return service;
  },
  async changeServicePosition(
    id: string,
    args: tChangeMasterServicePositionArgs
  ) {
    const { data } = await ServiceAPI.changePosition(id, args);
    websocket.execIfNotConnected(() => {
      MasterServiceMutationHandler.servicePositionChanged(data);
    });
  },
};
